import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { StudyModel } from '@app/interface';
import { DefaultActivity } from '@app/interface/activity';
import { UserDetail } from '@app/interface/auth.user';
import * as firebase from 'firebase';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FirebaseAuthService } from './firebaseauth.service';
import { StudiesService } from './studies.service';

@Injectable({
  providedIn: 'root',
})
export class ActivityService {
  constructor(
    private store: AngularFirestore,
    private afAuth: AngularFireAuth,
    private authServise: FirebaseAuthService,
    private studiesService: StudiesService
  ) {}

  public addDefaultActivity(defaultActivity: DefaultActivity, studyDetail: StudyModel) {
    return this.authServise.getUser().pipe(
      switchMap((user: UserDetail) => {
        defaultActivity.uuid = this.store.createId();
        defaultActivity.createdBy = user.role;
        defaultActivity.createdByUserId = user.uuid;
        defaultActivity.studyName = studyDetail.studyName;
        defaultActivity.studyRef = studyDetail.docRef;
        defaultActivity.studyId = studyDetail.uuid;
        defaultActivity.createdAt = firebase.default.firestore.Timestamp.now();
        defaultActivity.isDelete = false;

        return this.store
          .collection<DefaultActivity>('default-activities')
          .doc(defaultActivity.uuid)
          .set(defaultActivity, { merge: true });
      })
    );
  }

  public updateDefaultActivity(defaultActivity: DefaultActivity) {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        defaultActivity.updatedAt = firebase.default.firestore.Timestamp.now();
        defaultActivity.updatedByUserId = user.uid;
        return this.store
          .collection<DefaultActivity>('default-activities')
          .doc(defaultActivity.uuid)
          .update(defaultActivity);
      })
    );
  }

  public getDefaultActivities(studyName: string): Observable<any> {
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user) {
          return this.store
            .collection<DefaultActivity>('default-activities', (ref) => {
              let query: Query = ref;
              return query.where('studyName', '==', studyName).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }

  public getDefaultActivitieByStudyId(): Observable<any> {
    let studyId = this.studiesService.getStudyId();
    return this.afAuth.authState.pipe(
      switchMap((user: firebase.default.User) => {
        if (user && studyId) {
          return this.store
            .collection<DefaultActivity>('default-activities', (ref) => {
              let query: Query = ref;
              return query.where('studyId', '==', studyId).where('isDelete', '==', false).orderBy('createdAt', 'desc');
            })
            .valueChanges();
        } else {
          return of([]);
        }
      })
    );
  }
}
